import { PaymentExecutionTransfersDataTableDocument } from 'generated/resources/datatable.graphql'
import { RevokeTransfersToPaymentDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useRevokeTransfersMutation = () => {
  const [revokeTransfersBankingPayment, { loading }] = useMutation(
    RevokeTransfersToPaymentDocument,
    {
      extractorFn: (data) => data.bankingMutations.revokeTransfersBankingPayment,
      refetchQueries: [PaymentExecutionTransfersDataTableDocument],
      awaitRefetchQueries: true,
    }
  )

  const submitRevokeTransfers = async ({
    onSuccess,
    transferIds,
    paymentId,
  }: {
    onSuccess?: () => void
    transferIds: number[]
    paymentId: number
  }) => {
    const result = await revokeTransfersBankingPayment({
      variables: {
        paymentId: paymentId,
        transferIds: transferIds,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.bulk_payment.new_bulk_payment_modal.revoked_transfers'),
      })
      onSuccess?.()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitRevokeTransfers,
    loading,
  }
}
